<template>
    <div>
        <b-container>
            <h2>Instagram Banned Hashtags Tool</h2>
            <p>Remove banned hashtags before posting to Instagram:</p>
            <div class="content-area" v-if="!showHashtags"><font-awesome-icon :icon="['fas', 'spinner']" spin /></div>
            <div class="content-area" v-else>
                <HashtagInput :suggestedHashtags="suggestedHashtags" :bannedinsta=true  :copy=true  :clear=true />
            </div>
            <br>
            <div class="tired-warning">
                <b-alert variant="warning" class="devAlert" show>
                    <div class="warning-container">
                        <b>Developers:</b> Have banned hashtags automatically removed from your users posts with the
                        <a
                            href="https://ritekit.com/api-demo/banned-instagram-hashtags?_ga=2.61298671.277803399.1537120963-23137195.1535538769"
                            target="_blank"
                        >Ritetag API</a>
                    </div>
                </b-alert>
            </div>
        </b-container>
    </div>
</template>

<script>
import HashtagInput from "./helpers/HashtagInput";
import {api} from "../_services"
export default {
    name: 'HashtagSets',
    components: {
        HashtagInput
    },
    data() {
        return {
            hashtagsArea: '#instaphotography#instabeauty#instagirls#girlsofinstagram#instanature#instagirl#photography#beauty#girls#nature#girl#sky#water#balls#lady#ladies#woman#women#photograph#photographs#beauties#sunlight#sitting#waters#skies#sit#photographies',
            suggestedHashtags : [],
            showHashtags: false,
        }
    },
   methods: {
        fetchHashtag(type) {
            this.loading = true;
            let data = this.hashtagsArea.split('#').filter(x => x!=='')
            api.hashtagStats(data)
                .then(response => {
                this.showHashtags = true;
                this.suggestedHashtags = response.data.stats
                this.suggestedHashtags.shift();
                })
                .catch(err => {
                this.loading = false
                });
            }
    },
    created(){
        this.fetchHashtag()
    }

}
</script>

<style scoped>
[v-cloak] {
    display: none;
}
</style>
